export default __webpack_public_path__ + "static/media/notification.c5d9251e.ttf";